/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  JudgeRequestBody,
  JudgeRequestBody$Outbound,
  JudgeRequestBody$outboundSchema,
} from "../components/judgerequestbody.js";

export type LauncherJudgeSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type LauncherJudgeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  judgeRequestBody: JudgeRequestBody;
};

/** @internal */
export type LauncherJudgeSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const LauncherJudgeSecurity$outboundSchema: z.ZodMiniType<
  LauncherJudgeSecurity$Outbound,
  LauncherJudgeSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function launcherJudgeSecurityToJSON(
  launcherJudgeSecurity: LauncherJudgeSecurity,
): string {
  return JSON.stringify(
    LauncherJudgeSecurity$outboundSchema.parse(launcherJudgeSecurity),
  );
}

/** @internal */
export type LauncherJudgeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  JudgeRequestBody: JudgeRequestBody$Outbound;
};

/** @internal */
export const LauncherJudgeRequest$outboundSchema: z.ZodMiniType<
  LauncherJudgeRequest$Outbound,
  LauncherJudgeRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    judgeRequestBody: JudgeRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      judgeRequestBody: "JudgeRequestBody",
    });
  }),
);

export function launcherJudgeRequestToJSON(
  launcherJudgeRequest: LauncherJudgeRequest,
): string {
  return JSON.stringify(
    LauncherJudgeRequest$outboundSchema.parse(launcherJudgeRequest),
  );
}
